import { GridRowId } from '@mui/x-data-grid'
import axios from 'axios'

const uploadOrder = async (company: string, orderType: string, file: File) =>
  axios.post(
    `/daily-order/upload-orders`,
    {
      company,
      orderType,
      file
    },
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )

const markOrdersAsSpecialByFile = async (company: string, file: File) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('company', company)

  return axios.post(`/daily-order/mark-orders-special`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

const getOrders = async (
  company: string,
  orderType: string,
  boxPrefix?: string,
  skipBoxLookup?: boolean
) =>
  axios.get(`/daily-order/orders`, {
    params: {
      company,
      orderType,
      boxPrefix,
      ...(skipBoxLookup ? { skipBoxLookup: 'true' } : {})
    }
  })

const getOrderBySONumber = async (company: string, orderNumber: string) =>
  axios.get(`/daily-order/order-by-so`, {
    params: {
      company,
      orderNumber
    }
  })

const clearOrders = async (company: string) =>
  axios.post(`/daily-order/clear-orders`, {
    company
  })

const deleteOrders = async (company: string, orderIds: GridRowId[]) =>
  axios.delete(`/daily-order/delete-orders`, {
    data: {
      company,
      orderIds
    }
  })
const requireToCancelOrders = async (company: string, orderIds: GridRowId[]) =>
  axios.post(`/daily-order/cancel-orders`, {
    company,
    orderIds
  })

const getPendingCancelledOrders = async (company: string) =>
  axios.get(`/daily-order/pending-cancelled-orders`, {
    params: {
      company
    }
  })

const confirmCancellingOrder = async (company: string, orderNumber: string) =>
  axios.post(`/daily-order/confirm-cancelling-order`, {
    company,
    orderNumber
  })

const refuseCancellingOrder = async (company: string, orderNumber: string) =>
  axios.post(`/daily-order/refuse-cancelling-order`, {
    company,
    orderNumber
  })

const syncQTESSOrders = async (
  sessionId: string,
  company: string,
  startTime: string,
  endTime: string
) =>
  axios.post(`/daily-order/sync-qtess-orders`, {
    sessionId,
    company,
    startTime,
    endTime
  })

export {
  uploadOrder,
  getOrders,
  clearOrders,
  deleteOrders,
  getOrderBySONumber,
  requireToCancelOrders,
  getPendingCancelledOrders,
  confirmCancellingOrder,
  refuseCancellingOrder,
  syncQTESSOrders,
  markOrdersAsSpecialByFile
}
